import { list } from './tags';

function endpoints(builder) {
  return {
    getPortalAccessSubmissions: builder.query({
      query: ({ status }) => `tefaf/tefafportal/press-agents/submissions?status=${status}`,
      providesTags: list,
    }),
    acceptPortalAccessSubmission: builder.mutation({
      invalidatesTags: list,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/tefafportal/press-agents/accept');
        body.append('submissionId', values.submissionId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    rejectPortalAccessSubmission: builder.mutation({
      invalidatesTags: list,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/tefafportal/press-agents/reject');
        body.append('submissionId', values.submissionId);
        body.append('rejectionReason', values.rejectionReason);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
